// extracted by mini-css-extract-plugin
module.exports = {"cont":"NotAuth_cont__3BdE1","desc":"NotAuth_desc__3GIgD"};